import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ThirdPartySettings } from "../third-party.state";

export const openAiLinkActions = createActionGroup({
    source: 'OpenAI Link',
    events: {
        'Initialize': emptyProps(),
        'Load': props<{ settings: ThirdPartySettings }>(),
        'Loaded': props<{ settings: ThirdPartySettings }>()
    },
});
